
import { CommentWithVotes, CommentSortOption } from '../types';
import { fetchPollComments } from './pollComments';
import { fetchCardComments } from './cardComments';

/**
 * Fetch replies for a specific comment
 * @param commentId The parent comment ID
 * @param contentType The content type (poll or card)
 * @param limit Maximum number of replies to return
 * @param sortBy Sort option
 * @returns Array of reply comments
 */
export async function fetchCommentReplies(
  commentId: string,
  contentType: 'poll' | 'card' = 'poll',
  limit: number = 5,
  sortBy: CommentSortOption = 'newest'
): Promise<CommentWithVotes[]> {
  if (!commentId) {
    console.warn('fetchCommentReplies called without commentId');
    return [];
  }
  
  console.log(`Fetching replies for comment ${commentId} (${contentType})`);
  
  try {
    if (contentType === 'poll') {
      // For poll comments, we need to pass an empty string for poll ID
      // We're querying by parent_id instead of poll_id
      return await fetchPollComments('', limit, sortBy, commentId);
    } else {
      // For card comments, we need to pass an empty string for card ID
      // We're querying by parent_id instead of card_id
      return await fetchCardComments('', limit, sortBy, commentId);
    }
  } catch (error) {
    console.error('Error in fetchCommentReplies:', error);
    return [];
  }
}
